module.exports = __webpack_public_path__ + "img/Box_mini.bad0c54e.png";